export enum TipoCaptchaDesconexiones {
  V2 = 'desconexion-publico',
  V3 = 'desconexion-publico-v3',
}
